import { PortalRequest as request } from "@/utils/request";

// 分页查看
export const getOpenProjectList = (params, data) => {
  return request({
    url: "/op-open-project/page-list",
    method: "post",
    params: params,
    data,
  });
};

export const getOpenProjectCategory = () => {
  return request({
    url: "/op-open-project/get-project-category-list",
    method: "get",
  });
};

export const getOpenProductList = (params, data) => {
  return request({
    url: "/op-open-news/page-list",
    method: "post",
    params: params,
    data,
  });
};

export const getOpenProductCategory = () => {
  return request({
    url: "/op-open-news/get-news-category-list",
    method: "get",
  });
};

export const getOpenTechnologyList = (params, data) => {
  return request({
    url: "/op-open-technical/page-list",
    method: "post",
    params: params,
    data,
  });
};
